import { deleteTokenType } from './firebaseExport';

export const deleteToken: deleteTokenType = async (): Promise<void> => {};
